import { memo } from 'react';

import { type Board } from '@air/api/types';
import { EllipsisIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { DropdownMenuWithActionSheet } from '~/components/Menus/DropdownMenuWithActionSheet';

export type BoardAncestorsDropdownProps = {
  ancestors: Pick<Board, 'id' | 'title'>[];
  onBoardClick: (board: Pick<Board, 'id' | 'title'>) => void;
};

export const BoardAncestorsDropdown = memo(({ ancestors, onBoardClick }: BoardAncestorsDropdownProps) => (
  <DropdownMenuWithActionSheet
    isTitleHidden
    options={ancestors.map(({ id, title }) => ({
      id,
      label: title,
      onSelect: () => onBoardClick({ id, title }),
      type: 'item',
    }))}
    title="Ancestor"
    trigger={
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        icon={EllipsisIcon}
        label="See more boards in pop-up"
        size="small"
      />
    }
  />
));

BoardAncestorsDropdown.displayName = 'BoardAncestorsDropdowns';
